import script from "./BlogContentGeneration.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogContentGeneration.vue?vue&type=script&setup=true&lang=js"

import "./BlogContentGeneration.vue?vue&type=style&index=0&id=28f919f4&lang=scss&scoped=true"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28f919f4"]])

export default __exports__